import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_ADDITION_FAIL = "SHOP:GET_PRODUCT_ADDITION";

export const getProductAdditionFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT_ADDITION_FAIL as typeof GET_PRODUCT_ADDITION_FAIL,
  organization,
  id,
});

export type GetProductAdditionFailAction = ReturnType<
  typeof getProductAdditionFailAction
>;
